import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { deleteBusinessId } from '../actions/homeAction';
const DeleteBusinessData = () => {
	const [Deleteid, setDeleteid] = useState({ id: '' });
	const handleChange = event => {
		setDeleteid({ [event.target.name]: event.target.value });
		console.log('delete business data', Deleteid);
	};

	const dispatch = useDispatch();
	const onSaveData = () => {
		console.log('delete business data', Deleteid.id);
		dispatch(deleteBusinessId({ garageOwnerId: Deleteid.id }));
		setDeleteid({ id: '' });
	};

	return (
		<div>
			<div className=''>
				<div className='card-body'>
					<div className='row'>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Business id</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='id'
										// id='name'
										placeholder='business id'
										onChange={handleChange}
										value={Deleteid.id}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className='row float-right p-3'>
						<button onClick={onSaveData} className='btn btn-grd-disabled mr-2'>
							<i className='icofont icofont-save'></i> delete
						</button>

						<Link to='' className='btn btn-outline-dark'>
							Cancel
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};
export default DeleteBusinessData;
